import { Component } from '@angular/core';

@Component({
    selector: 'landing-business-blog',
    imports: [],
    templateUrl: './blog.component.html',
    styleUrl: './blog.component.scss'
})
export class LandingBusinessBlogComponent {

}
